import { FC } from "react";
import { useWatch } from "react-hook-form";

import { ICustomField, IDataUploadMetadata, METADATA_KEY } from "@ryde/shared";

import { EtlSummaryCard } from "../../common";
import { DataUploadLogViewer } from "./data-upload-log-viewer";

/**
 * Read-only view of an data upload's last run, for the customer Data Uploads panel: the summary card and
 * the collapsible last-run log below it.
 *
 * It is a single form template so the schema can place it like any other control — one `data_upload_run_summary`
 * field, no bespoke slot in the edit drawer. The card and the log viewer are composed here rather than
 * being two separate schema fields, since they are always shown together and share the same watched row.
 *
 * The whole `metadata` object is watched, not the individual keys, because the card needs four of them
 * and they always arrive together on one row.
 */
export const DataUploadRunSummaryTemplate: FC<ICustomField> = () => {
  const metadata: IDataUploadMetadata | undefined = useWatch({
    name: METADATA_KEY,
  });
  const dataUploadId: number | undefined = useWatch({ name: "id" });

  return (
    <>
      <EtlSummaryCard
        summary={metadata?.lastRunSummary ?? undefined}
        finishedAt={metadata?.lastRunAt}
        rowsRead={metadata?.lastRunRowsRead ?? undefined}
        rowsWritten={metadata?.lastRunRowsWritten ?? undefined}
      />
      <DataUploadLogViewer dataUploadId={dataUploadId} />
    </>
  );
};
